<lib-dialog-layout>
    <ng-container title>
        <div class="d-flex justify-content-between">
            <h3>{{ data.Title }}</h3>
        </div>
    </ng-container>
    <ng-container content>
        <p [ngClass]="{'text-center': isMobile}" [innerHTML]="data.Text! | trustHtml"></p>
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            <lib-button
            [role]="ButtonRole.Primary"
                id="LibraryDialogSecondaryButton"
                [kind]="ButtonKind.Secondary"
                qaTag="warning-dialog-primary-action-button"
                (clicked)="PrimaryAction()">
                <ng-container label>
                    {{ primaryButtonText }}
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
